var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconillustrationTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55475_18847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9324 62.0123C45.7343 62.0123 56.9229 50.8237 56.9229 37.0218C56.9229 23.2199 45.7343 12.0312 31.9324 12.0312C18.1305 12.0312 6.94183 23.2199 6.94183 37.0218C6.94183 43.1547 9.15105 48.7717 12.8171 53.1202L10.7132 59.9984C10.4864 60.7396 11.2168 61.4145 11.9379 61.1301L18.9347 58.3705C22.7217 60.681 27.1715 62.0123 31.9324 62.0123Z",
    fill: "#BED8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1976,
    y: 27.7676,
    width: 20.8254,
    height: 4.62788,
    rx: 2.31394,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1976,
    y: 37.0234,
    width: 9.71854,
    height: 4.62788,
    rx: 2.31394,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1633 33.3659L51.0618 26.9792C51.5329 25.4593 50.6692 23.8478 49.1427 23.3984C47.6239 22.9513 46.0316 23.8265 45.595 25.3484L44.2386 30.0774L40.6889 41.5438C40.4183 42.4177 39.2823 42.6362 38.7069 41.9249L35.4363 37.8819C34.2427 36.3739 32.0413 36.145 30.5629 37.3751C29.2868 38.4369 28.9208 40.624 29.7437 42.0658L36.3616 53.5823C38.552 57.5591 41.8631 60.7321 46.6509 61.9772C53.9851 63.8845 61.2457 60.6012 63.9187 54.2996L69.5385 39.9423L70.2333 38.2011C70.8173 36.8747 70.2011 35.3271 68.8651 34.7652C67.5439 34.2095 66.0223 34.8309 65.4678 36.1527L64.0437 39.5477L62.8158 42.7757C62.6578 43.1913 62.1938 43.4012 61.7774 43.2456C61.3592 43.0893 61.1468 42.6236 61.3031 42.2054L62.3364 38.8603L64.3683 32.0024C64.7584 30.6449 63.9739 29.2283 62.6163 28.8387C61.259 28.4492 59.8429 29.2338 59.4534 30.591L58.0978 35.5069L57.3124 38.5272C57.1732 39.0623 56.6267 39.3832 56.0917 39.2441C55.5566 39.1049 55.2357 38.5584 55.3748 38.0233L58.2385 27.0115C58.6295 25.5081 57.7277 23.9725 56.2243 23.5815C54.7106 23.1879 53.1665 24.1047 52.7876 25.6222L50.4923 34.8067L49.692 37.884C49.5692 38.3561 49.087 38.6393 48.6149 38.5165C48.1428 38.3937 47.8596 37.9115 47.9824 37.4394L49.1633 33.3659Z",
    fill: "#1162FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7636 14.6349C60.7646 14.8088 60.7119 14.9788 60.6124 15.1214C60.513 15.2641 60.3719 15.3724 60.2085 15.4314L57.4571 16.4444L56.445 19.196C56.385 19.3589 56.2766 19.4996 56.1343 19.5989C55.992 19.6983 55.8226 19.7515 55.6491 19.7515C55.4756 19.7515 55.3063 19.6983 55.1639 19.5989C55.0216 19.4996 54.9132 19.3589 54.8532 19.196L53.8385 16.4476L51.0886 15.4346C50.9258 15.3746 50.7853 15.2661 50.686 15.1237C50.5868 14.9812 50.5335 14.8118 50.5335 14.6381C50.5335 14.4644 50.5868 14.295 50.686 14.1525C50.7853 14.0101 50.9258 13.9016 51.0886 13.8416L53.84 12.8286L54.8522 10.0771C54.9121 9.91409 55.0206 9.77344 55.1629 9.6741C55.3052 9.57475 55.4745 9.52148 55.648 9.52148C55.8215 9.52148 55.9909 9.57475 56.1332 9.6741C56.2755 9.77344 56.384 9.91409 56.4439 10.0771L57.456 12.8307L60.2053 13.8437C60.3685 13.902 60.5097 14.0092 60.6096 14.1508C60.7095 14.2925 60.7633 14.4615 60.7636 14.6349Z",
    fill: "url(#paint0_linear_55475_18847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3321 10.0892C61.3325 10.1472 61.3149 10.2039 61.2818 10.2514C61.2486 10.299 61.2016 10.3351 61.1471 10.3547L60.23 10.6924L59.8926 11.6096C59.8726 11.6639 59.8365 11.7108 59.789 11.7439C59.7416 11.777 59.6851 11.7948 59.6273 11.7948C59.5695 11.7948 59.513 11.777 59.4656 11.7439C59.4181 11.7108 59.382 11.6639 59.362 11.6096L59.0238 10.6935L58.1072 10.3558C58.0529 10.3358 58.006 10.2996 57.9729 10.2522C57.9399 10.2047 57.9221 10.1482 57.9221 10.0903C57.9221 10.0324 57.9399 9.97593 57.9729 9.92845C58.006 9.88097 58.0529 9.8448 58.1072 9.8248L59.0243 9.48714L59.3617 8.56996C59.3816 8.51563 59.4178 8.46875 59.4652 8.43564C59.5127 8.40252 59.5691 8.38477 59.627 8.38477C59.6848 8.38477 59.7412 8.40252 59.7887 8.43564C59.8361 8.46875 59.8723 8.51563 59.8922 8.56996L60.2296 9.48785L61.146 9.82551C61.2004 9.84492 61.2475 9.88068 61.2808 9.92788C61.3141 9.97509 61.332 10.0314 61.3321 10.0892Z",
    fill: "url(#paint1_linear_55475_18847)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55475_18847",
    x1: 50.5335,
    y1: 9.43369,
    x2: 61.7193,
    y2: 10.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7621FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55475_18847",
    x1: 57.9221,
    y1: 8.3555,
    x2: 61.6507,
    y2: 8.74933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7621FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55475_18847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 11.491,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconillustrationTutorial);
export default __webpack_public_path__ + "static/media/icon.illustration_tutorial.66e4d3ded012a55bdcb617f26f2c0cab.svg";
export { ForwardRef as ReactComponent };